import { FC } from "react";
import { clsxMerge } from "shared/lib/helpers";
import { CheckCircleIcon } from "@heroicons/react/24/outline";

export interface EmailFormActionsSectionI {
  isSendingEmail?: boolean;
  isSendEmailSuccess?: boolean;
  isEmailsValid?: boolean;
  isAIGenerating?: boolean;
  onSubmit?: () => void;
  className?: string;
}

/**
 * Email Form Actions Section
 * @param isSendingEmail - Whether the email is being sent
 * @param isSendEmailSuccess - Whether the email has been sent successfully
 * @param isAIGenerating - Whether the email is being generated by AI
 * @param onSubmit - The function to call when the email is submitted
 * @param className - The className to apply to the section
 * @returns The Email Form Actions Section
 */
export const EmailFormActionsSection: FC<EmailFormActionsSectionI> = ({
  isSendingEmail,
  isSendEmailSuccess,
  // isEmailsValid,
  isAIGenerating,
  onSubmit,
  className,
}) => {
  return (
    <section
      className={clsxMerge(
        "relative",
        "flex items-center justify-end",
        "overflow-hidden",
        "rounded-md",
        "gap-4 p-4",
        className
      )}
    >
      <div className="absolute left-0 top-0 z-[0] h-full w-full bg-black/10 backdrop-blur-sm" />
      <button
        type="button"
        className={clsxMerge("btn-ae-default z-[1] min-w-[120px]", {
          loading: isSendingEmail,
          "btn-nofill pointer-events-none": isSendEmailSuccess,
        })}
        disabled={isAIGenerating || isSendingEmail}
        onClick={onSubmit}
      >
        {isSendEmailSuccess ? (
          <span className="flex items-center gap-1">
            SENT <CheckCircleIcon className="w-5" />
          </span>
        ) : (
          "SEND"
        )}
      </button>
    </section>
  );
};
